import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Input from 'material-ui/Input';
import IconButton from 'material-ui/IconButton';
import BackspaceIcon from 'material-ui-icons/Backspace';
import ClearIcon from 'material-ui-icons/Clear';
import axios from 'axios';
import AuthService from '../AuthService';
import { Redirect } from 'react-router-dom';
import InPersonDialog from './InPersonDialog';

const styles = theme => ({
  outer: {
    position: 'absolute',
    left: 0,
    top: '15%',
    right: 0,
    bottom: 0
  },
  inner: {
    position: 'absolute',
    top: '37%',
    transform: 'translate(0, -50%)'
  },
  button: {
    backgroundColor: 'white',
    border: 'solid #227a90 1px',
    borderRadius: 50 + '%',
    fontSize: 22,
    color: '#455560',
    height: 90,
    padding: '0 39px',
    boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)',
    margin: '1.5%',
    '&:hover': { backgroundColor: 'white' },
    '&:focus': { outline: 0 }
  },
  iconButton: {
    margin: '2.5%',
    boxShadow: 0
  }
});

const errorMessage = {
  color: '#E83030',
  margin: 0,
  fontSize: '1rem',
  minHeight: '1em',
  marginTop: '8px',
  marginBottom: '16px',
  fontFamily: 'Gudea',
  lineHeight: '1em'
};

class Keypad extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      inputValue: '',
      user: this.Auth.getUser(),
      userAuthenticated: this.Auth.userAuthenticated(),
      codeError: null,
      open: false,
      showHostContent: false,
      showSigningContent: false,
      showCancelContent: false,
      signingDocument: {},
      signingParticipant: []
    };
    this.updateInputValue = this.updateInputValue.bind(this);
    this.deleteInputValue = this.deleteInputValue.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.submitCode = this.submitCode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onStartHosting = this.onStartHosting.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onActivateCancelContent = this.onActivateCancelContent.bind(this);
  }

  handleClose() {
    this.setState({
      open: false,
      inputValue: ''
    });
  }

  onStartHosting() {
    this.setState({
      showHostContent: false,
      showSigningContent: true
    });
  }

  onActivateCancelContent() {
    this.setState({
      showSigningContent: false,
      showCancelContent: true
    });
  }

  UNSAFE_componentWillMount() {
    // Prevents elastic scroll
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
  }

  componentWillUnmount() {
    // Resets css from above
    document.body.style.overflow = null;
    document.body.style.position = null;
  }

  handleChange(event) {
    // handle keydown
    let value = event.target.value;

    if (value.length <= 6) {
      this.setState({
        inputValue: value,
        codeError: ''
      });
    }

    if (value && value.length === 6) {
      this.submitCode(event, value);
    }
  }

  updateInputValue(e, value) {
    // handle tap/click
    // prevent default zoom in behavior
    e.preventDefault();

    let currentValue = this.state.inputValue;
    let newValue = currentValue + value;

    if (newValue.length <= 6) {
      this.setState({
        inputValue: newValue,
        codeError: ''
      });
    }

    if (newValue && newValue.length === 6) {
      this.submitCode(e, newValue);
    }
  }

  deleteInputValue(e) {
    let str = this.state.inputValue;
    // prevent default zoom in behavior
    e.preventDefault();
    this.setState({
      inputValue: str.slice(0, -1),
      codeError: ''
    });
  }

  clearInput(e) {
    // prevent default zoom in behavior
    e.preventDefault();
    this.setState({
      inputValue: '',
      codeError: ''
    });
  }

  submitCode(e, value) {
    const searchParams = '?ipscode=' + value;

    axios(
      `${process.env.REACT_APP_API_URL}/documents/kiosk/inperson` +
        searchParams,
      {
        method: 'GET',
        mode: 'cors'
      }
    )
      .then(response => {
        const documentReady = response.data;
        let inPersonParticipant = [];
        for (var i = 0; i < documentReady.participants.length; i++) {
          const participantSigning = documentReady.participants[i];
          if (
            participantSigning.inPerson &&
            !participantSigning.signedOrApproved
          ) {
            inPersonParticipant.push(participantSigning);
          }
        }
        this.setState({
          open: true,
          showHostContent: true,
          showSigningContent: false,
          showCancelContent: false,
          signingDocument: documentReady,
          signingParticipant: inPersonParticipant[0]
        });
      })
      .catch(e => {
        this.setState({
          codeError: 'Invalid code. Please enter a valid code to continue.'
        });
      });
  }

  renderButtons() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container alignItems="center" justify="center">
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 1)}
          >
            1
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 2)}
          >
            2
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 3)}
          >
            3
          </button>
        </Grid>

        <Grid container alignItems="center" justify="center">
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 4)}
          >
            4
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 5)}
          >
            5
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 6)}
          >
            6
          </button>
        </Grid>

        <Grid container alignItems="center" justify="center">
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 7)}
          >
            7
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 8)}
          >
            8
          </button>
          <button
            className={classes.button}
            onClick={e => this.updateInputValue(e, 9)}
          >
            9
          </button>
        </Grid>
      </div>
    );
  }

  renderInput() {
    const { codeError, inputValue } = this.state;

    return (
      <Grid container direction="row" alignItems="center" justify="center">
        <Input
          type="text"
          value={inputValue}
          onChange={event => this.handleChange(event)}
          placeholder="Document Code"
          style={{ fontSize: 28 }}
          error={codeError ? true : false}
          margin="dense"
        />
      </Grid>
    );
  }

  renderError() {
    const { codeError } = this.state;

    return (
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        style={{ marginBottom: 10 }}
      >
        {codeError && <p style={errorMessage}>{codeError}</p>}
      </Grid>
    );
  }

  renderLastKeypadRow() {
    const { classes } = this.props;
    const { inputValue } = this.state;

    return (
      <Grid container alignItems="center" justify="center">
        <IconButton
          onClick={e => this.clearInput(e)}
          disabled={!inputValue.length}
          className={classes.iconButton}
          color="secondary"
          aria-label="Submit"
        >
          <ClearIcon style={{ fontSize: 36 }} />
        </IconButton>
        <button
          className={classes.button}
          onClick={e => this.updateInputValue(e, 0)}
        >
          0
        </button>

        <IconButton
          onClick={e => this.deleteInputValue(e)}
          className={classes.iconButton}
          color="primary"
          disabled={!inputValue.length}
          aria-label="Delete"
        >
          <BackspaceIcon style={{ fontSize: 36 }} />
        </IconButton>
      </Grid>
    );
  }

  renderInPersonDialog() {
    const {
      signingParticipant,
      signingDocument,
      open,
      showHostContent,
      showSigningContent,
      showCancelContent
    } = this.state;

    return (
      <InPersonDialog
        participant={signingParticipant}
        document={signingDocument}
        open={open}
        showHostContent={showHostContent}
        showSigningContent={showSigningContent}
        showCancelContent={showCancelContent}
        onStartHosting={this.onStartHosting}
        onStartSigning={this.onStartSigning}
        onActivateCancelContent={this.onActivateCancelContent}
        onClose={this.handleClose}
      />
    );
  }

  render() {
    const { classes } = this.props;
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { userAuthenticated, user } = this.state;

    if (
      userAuthenticated === false ||
      user === false ||
      !localStorage.userGroup ||
      localStorage.userGroup === false
    ) {
      return <Redirect to={from} />;
    }

    return (
      <div className={classes.outer}>
        <Grid container justify="center" spacing={24} className={classes.inner}>
          <Grid item xs={12}>
            {this.renderInput()}
            {this.renderError()}
            {this.renderButtons()}
            {this.renderLastKeypadRow()}
          </Grid>
        </Grid>

        {this.renderInPersonDialog()}
      </div>
    );
  }
}

export default withStyles(styles)(Keypad);



// WEBPACK FOOTER //
// ./src/components/Keypad.js